import { CardFooter } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const NotificationCardFooter = styled(CardFooter)`
  width: 100%;
  padding: 3rem 0;
`;
